<div class="linea-temporal text-center m-auto">

  <div class="contenido c1">
    <p class="tapa"> +1980</p>
    <img class="img-contenido" src="../../../../assets/img/FOTO JUAN RECORTADA.jpg" alt="">
    <p>A mediados de la década del ochenta, un grupo de familias cristianas,
      comprometidas con la realidad y guiadas por el P. Juan De Laurenti en la Pquia
      Corpus Dominis trabajaron en el proyecto que se basababa en la premisa de “...proteger la vida que
      crece...”</p>
  </div>

  <div class="flecha m-auto f1">
    <img class="flecha-pantalla" src="../../../../assets/img/flecha-derecha.png" alt="">
    <img class="flecha-telefono" src="../../../../assets/img/descargar.png" alt="">
  </div>

  <div class="contenido c2">
    <p class="tapa">+1980</p>
    <img class="img-contenido" src="../../../../assets/img/foto-nuestro-equipo-5.jpg" alt="">
    <p>Se comienzan a desarrollar actividades relacionadas con la promoción de los
      niños(as) y familias en situación de vulnerabilidad. Además orientar y acompañar la
      adopción. Conformamos un equipo de personas con experiencias en el tema. Abogados,
      Trabajadoras Sociales, Psicólogos y alguna familia que tuvo esa experiencia de
      adoptar menores.</p>
  </div>

  <div class="flecha-abajo  m-auto f2">
    <img class="flecha-pantalla" src="../../../../assets/img/flecha-hacia-abajo.png" alt="">
    <img class="flecha-telefono" src="../../../../assets/img/descargar.png" alt="">

  </div>

  <div class="contenido c3">
    <p class="tapa">1988</p>
    <img class="img-contenido logo" src="../../../../assets/img/logo.png" alt="">
    <p>Se creo la Asociación Civil Jesús Amigo.
      Durante varios años comenzamos colaborando con una Hogar Transitorio en el barrio Villa Luro. Allí
      comenzamos a trabajar e interiorizarnos con la dinámica
      de los Hogares de Menores.</p>
  </div>

  <div class="flecha m-auto f3">
    <img class="flecha-pantalla" src="../../../../assets/img/flecha-hacia-la-izquierda.png" alt="">
    <img class="flecha-telefono" src="../../../../assets/img/descargar.png" alt="">

  </div>

  <div class="contenido c4">
    <p class="tapa">1998</p>
    <img class="img-contenido" src="../../../../assets/img/img116.jpg" alt="">
    <p>Se empezo a
      trabajar para
      contar con un nuevo hogar. El 4 de julio se realizó la bendición e inauguración del
      Hogar “Madre de la Esperanza” y se abrieron las puertas en agosto de 1998.</p>
  </div>

  <div class="flecha-abajo m-auto f4">
    <img class="flecha-rotacion flecha-pantalla" src="../../../../assets/img/anterior.png" alt="">
    <img class="flecha-telefono" src="../../../../assets/img/descargar.png" alt="">

  </div>



  <div class="contenido c5">
    <p class="tapa">2000</p>
    <img class="img-contenido" src="../../../../assets/img/img108.jpg" alt="">
    <p>Se adquirió una segunda vivienda para que funcione en ella nuestro
      hogar de varones. El 15 de octubre de 2000 se realizó la bendición e inauguración del Hogar
      "Nochebuena"; con una misa presidida por el Cardenal Jorge Bergoglio.</p>
  </div>

  <div class="flecha m-auto f5">
    <img class="flecha-pantalla" src="../../../../assets/img/flecha-derecha.png" alt="">
    <img class="flecha-telefono" src="../../../../assets/img/descargar.png" alt="">

  </div>

  <div class="contenido c6">
    <p class="tapa">ACTUALIDAD</p>
    <img class="img-contenido" src="../../../../assets/img/actualidad.jpg" alt="">
    <p>Y seguimos accionando en el
      Evangelio de Jesucristo, en la enseñanza de nuestros obispos y en la legislación
      que protege y promueve la vida, la dignidad y los derechos de lo niños(as).Esto implica una invitación a
      comprometernos
      en la creación de ámbitos propicios para que los niños/as con problemáticas
      sociales puedan desarrollarse integralmente.</p>
  </div>



</div>
